import * as ui from "../ui";

var view = () => new ui.Container({
    classes: "col-xs-12",
    components: [
        new ui.Container({
            id: "EditContainer",
            classes: "col-xs-4 mar-b-20",
            components: [
                new ui.Label({
                    bindValue: "EnteredCoordinates",
                    label: "EnteredCoordinates",
                    classes: "bold mar-b-20"
                }),
                new ui.NumericInput({
                    id: "UserLatitude",
                    bindValue: "Latitude",
                    label: "Latitude",
                    bsc: "col-xs-12",
                    labelBsc: "col-xs-4",
                    min: "-90",
                    max: "90",
                    decimals: "8",
                    step: 0.1,
                    format: "#.########°"
                }),
                new ui.NumericInput({
                    id: "UserLongitude",
                    bindValue: "Longitude",
                    label: "Longitude",
                    bsc: "col-xs-12",
                    labelBsc: "col-xs-4",
                    min: "-180",
                    max: "180",
                    decimals: "8",
                    step: 0.1,
                    format: "#.########°"
                }),
                new ui.Container({
                    id: "UserLatLong",
                    components: [
                        new ui.Link({
                            id: "UseEnteredCoord",
                            bindLabel: "UseEnteredCoord",
                            bindClass: "bind-label right",
                            bsc: "js-message-link right mar-b-20"
                        }),
                        new ui.Label({
                            bindValue: "MapCoordinates",
                            bsc: "col-xs-12",
                            labelBsc: "col-xs-4",
                            classes: "bold"
                        }),
                        new ui.NumericInput({
                            id: "EnteredLatitude",
                            bindValue: "Latitude",
                            label: "Latitude",
                            bsc: "col-xs-12",
                            labelBsc: "col-xs-4",
                            min: "-90",
                            max: "90",
                            decimals: "8",
                            step: 0.1,
                            format: "#.########° ",
                            disabled: true,
                            readonly: true
                        }),
                        new ui.NumericInput({
                            id: "EnteredLongitude",
                            bindValue: "Longitude",
                            label: "Longitude",
                            bsc: "col-xs-12",
                            labelBsc: "col-xs-4",
                            min: "-180",
                            max: "180",
                            decimals: "8",
                            step: 0.1,
                            format: "#.########° ",
                            disabled: true,
                            readonly: true
                        })
                    ]
                })
            ]
        }),
        new ui.Container({
            id: "MapViewContainer",
            classes: "col-xs-7",
            components: [
                new ui.Container({
                    id: "Map",
                    bsc: "latLongMap"
                })
            ]
        })
    ]
});

export default view;
